let url;
if(localStorage.getItem("isLocal")==="true"){
    url = process.env.REACT_APP_SERVER_URL_2;
}else {
    url = process.env.REACT_APP_SERVER_URL;
}
export const SERVER = url;
export const VERSION = "/api/v1";
export const SERVER_FULL_PATH = SERVER + VERSION;
export const LOGIN = `${SERVER}${VERSION}/auth/jwt/create/`;
export const REFRESH_USER = `${SERVER}${VERSION}/auth/jwt/refresh/`;
export const FETCH_USER = `${SERVER}${VERSION}/auth/me/`;
export const PASSWORD_UPDATE = `${SERVER}${VERSION}/auth/users/set_password/`;
export const USER_BASE = "/auth/users/";
export const LOGIN_BASE = "/auth/jwt/create/";
export const EVENTS = "/events/";
export const PACKAGE_PLANS = "/package_plans/";
export const ORGANIZATION = "/organizations/";
export const PHOTOGRAPHS = SERVER_FULL_PATH + "/photographs/";
export const PHOTO_SEARCH = SERVER_FULL_PATH + "/photo_searches/";
export const IS_UNIQUE = SERVER_FULL_PATH + "/verification/isunique/";
export const OTP = SERVER_FULL_PATH + "/verification/otp/";
export const OTP_REG_LOGIN = SERVER_FULL_PATH + "/verification/otpreglogin/";
export const PASSWORD_RESET = SERVER_FULL_PATH + "/verification/password/reset/";
//TODO şifre yenileme verification/password/reset/ endpointi ile


